// src/utils/partnerMap.js
import domainListJson from "../data/domainList.json";

export function getDomainsForPartner(partnerName) {
	if (!partnerName) return ["all"];

	const partners = domainListJson.partners || {};
	const domainList = partners?.[partnerName]?.domainList;

	// normalize to lowercase "all" for your dashboard logic
	return Array.isArray(domainList) && domainList.length ? domainList : ["all"];
}

export function getPartnerOptions() {
	const partners = domainListJson.partners || {};
	const keys = Object.keys(partners);

	return keys;
}

export function getPartnerLabel(partnerKey) {
	const partners = domainListJson.partners || {};
	return partners?.[partnerKey]?.displayName || partnerKey;
}

export function getDefaultPartnerAlias() {
	const opts = getPartnerOptions();
	return opts?.[0] || "liqwid";
}
